/* Hook for MercadoLibre data using SWR pattern
Consistent with existing SWR implementation in the codebase
Autor: Assistant
Fecha: 2025-06-24
*/
import useSWR from 'swr'

import useMeliFetcher from './useMeliFetcher'
import useLocalization from './useLocalization'

interface CategoryAttr {
  brands: string[]
  colors: string[]
  fuel: string[]
  gearbox: string[]
  bodies: string[]
}

// SWR hook for MercadoLibre category attributes
export const useMeliCategoryAttributes = () => {
  const { meliCategoryAttr } = useMeliFetcher()

  return useSWR<CategoryAttr | null>('meli-category-attr', meliCategoryAttr, {
    revalidateOnFocus: false, // Disable auto-refresh when window gains focus
    revalidateOnReconnect: false, // Disable auto-refresh on network recovery
    refreshInterval: 0, // Disable polling/interval refreshing
    revalidateIfStale: false, // Don't auto-refresh if data becomes stale
    dedupingInterval: 300000, // Cache for 5 minutes (300 seconds)
  })
}

// SWR hook for MercadoLibre types
export const useMeliTypes = () => {
  const { meliTypes } = useMeliFetcher()

  return useSWR<Record<string, string> | null>('meli-types', meliTypes, {
    revalidateOnFocus: false,
    revalidateOnReconnect: false,
    refreshInterval: 0,
    revalidateIfStale: false,
    dedupingInterval: 300000, // Cache for 5 minutes
  })
}

// SWR hook for municipalities/regions
export const useMunicipalities = () => {
  const { fetchMunicipalities } = useLocalization()

  return useSWR('municipalities', fetchMunicipalities, {
    revalidateOnFocus: false,
    revalidateOnReconnect: false,
    refreshInterval: 0,
    revalidateIfStale: false,
    dedupingInterval: 600000, // Cache for 10 minutes (600 seconds)
  })
}

export default {
  useMeliCategoryAttributes,
  useMeliTypes,
  useMunicipalities,
}
